/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/ChallengeFactory',[
    'Solitaire/DailyChallenges/KlondikeChallenge',
    'Solitaire/DailyChallenges/FreeCellChallenge',
    'Solitaire/DailyChallenges/PyramidChallenge',
    'Solitaire/DailyChallenges/SpiderChallenge',
    'Solitaire/DailyChallenges/TriPeaksChallenge'],
    function (KlondikeChallenge, FreeCellChallenge, PyramidChallenge, SpiderChallenge, TriPeaksChallenge) {
    "use strict";

    var ChallengeFactory = {

        BuildChallengeObject: function (challengeConfig) {

            var challenge;
            if (challengeConfig) {
                switch (challengeConfig.Data.GameMode) {
                    case "Klondike":
                        challenge = new KlondikeChallenge.FromDictionary(challengeConfig);
                        break;

                    case "FreeCell":
                        challenge = new FreeCellChallenge.FromDictionary(challengeConfig);
                        break;

                    case "Pyramid":
                        challenge = new PyramidChallenge.FromDictionary(challengeConfig);
                        break;

                    case "Spider":
                        challenge = new SpiderChallenge.FromDictionary(challengeConfig);
                        break;

                    case "TriPeaks":
                        challenge = new TriPeaksChallenge.FromDictionary(challengeConfig);
                        break;


                    default:
                        challenge = null;

                }
            }
            return challenge;
        }

    };

    return ChallengeFactory;

});
